(function () {
  function getCountsFromURL() {
    const params = new URLSearchParams(window.location.search);
    const counts = {};
    params.forEach(function (value, key) {
      if (!counts[key]) counts[key] = 0;
      counts[key]++;
    });
    return counts;
  }

  function updateBadges() {
    const counts = getCountsFromURL();
    const skipFilters = ['pf_rs2_width', 'pf_rs3_height'];

    document.querySelectorAll('.boost-sd__filter-option[data-filteroptionid]').forEach(function (section) {
      const filterId = section.getAttribute('data-filteroptionid');
      if (skipFilters.includes(filterId)) return;

      const titleButton = section.querySelector('.boost-sd__filter-option-title');
      if (!titleButton) return;
      let badge = titleButton.querySelector('.filter-count-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'filter-count-badge';
        badge.style.cssText = `
          border-radius: 10px;
          font-size: 17px;
          font-weight: 600;
          min-width: 18px;
          height: 18px;
          line-height: 6px;
          text-align: center;
          margin-left: 5px;
          vertical-align: middle;
          box-sizing: border-box;
          position: relative;
          bottom: -6px;
        `;
        const svg = titleButton.querySelector('svg');
        svg ? titleButton.insertBefore(badge, svg) : titleButton.appendChild(badge);
      }
      const count = counts[filterId] || 0;
      badge.textContent = count > 0 ? `(${count})` : '';
    });
  }

  let lastUrl = location.href;
  setInterval(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateBadges, 400);
    }
    updateBadges();
  }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadges);
  } else {
    updateBadges();
  }
})();